export default __webpack_public_path__ + "static/media/upperarrow.bb8132b2.svg";